import { render, staticRenderFns } from "./selectMarket.vue?vue&type=template&id=5b0e5ef6&scoped=true&"
import script from "./selectMarket.vue?vue&type=script&lang=js&"
export * from "./selectMarket.vue?vue&type=script&lang=js&"
import style0 from "./selectMarket.vue?vue&type=style&index=0&id=5b0e5ef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e5ef6",
  null
  
)

export default component.exports